import type { FC, ReactElement } from 'react';

import { HelpText } from '../../../services/helpTranslations/reactBindings/HelpText';
import { useModifiers } from '../../../styles/hooks/useModifiers';
import type { HelpAccordionProps } from '../types';

import { HelpChapter } from './HelpChapter';

import styles from './HelpAccordion.module.css';

export const HelpAccordion: FC<HelpAccordionProps> = ({
  helpConfig,
  isRTL,
  chaptersToHide,
  defaultOpenChapters = [],
}): ReactElement => {
  const mods = useModifiers(styles, 'help', { rtl: isRTL }, { withBaseClass: true });

  return (
    <div className={mods}>
      {Object.entries(helpConfig.chapters).map(([chapterName, Sections]) => {
        if (chaptersToHide?.includes(chapterName)) {
          return null;
        }
        return (
          <HelpChapter
            chapterName={chapterName}
            isOpen={defaultOpenChapters.includes(chapterName)}
            key={chapterName}
            title={<HelpText tk={`${chapterName}.title`} />}
          >
            <Sections />
          </HelpChapter>
        );
      })}
    </div>
  );
};
